export default __webpack_public_path__ + "static/media/tcouncil.6a8edd98.png";